import { get } from 'lodash';
import { connect } from 'react-redux';

import LandingPage from 'components/LandingPage';
import { HERO_TYPES } from 'constants/landingPage';
import Hero from 'models/Hero';
import SecondaryPromoHero from 'models/SecondaryPromoHero';
import * as actions from 'state/actions';
import { MODAL_TYPES } from 'state/constants';

const mapStateToProps = (state, ownProps) => {
  const { data, modalSettings, hasCountdownTimer } = ownProps;
  const { hero, pageSections, scheduledDropDatetime } = data;
  const heroType = get(data, ['hero', '_contentType']);
  let heroModel = null;

  if ([HERO_TYPES.PRIMARY_HERO, HERO_TYPES.PRIMARY_HERO_V3].includes(heroType)) {
    heroModel = new Hero(hero);
  } else if (heroType === HERO_TYPES.SECONDARY_PROMO_HERO) {
    heroModel = new SecondaryPromoHero(hero);
  }

  const isModalOpen = get(state, ['app', 'modal']) === MODAL_TYPES.LANDING_PAGE_HERO_VIDEO;

  return {
    hero: heroModel,
    heroType,
    pageSections,
    scheduledDropDatetime,
    hasCountdownTimer,
    isModalOpen,
    modalSettings,
  };
};

const mapDispatchToProps = dispatch => ({
  trackEvent: ({ eventAction, eventLabel, eventValue }) =>
    dispatch(actions.trackLandingPageEvent({ eventAction, eventLabel, eventValue })),
  openModal: () => dispatch(actions.openLandingPageHeroVideoModal()),
  closeModal: () => dispatch(actions.closeModal()),
  signUpForNewsletter: params => dispatch(actions.signUpForNewsletter(params)),
});

export default connect(mapStateToProps, mapDispatchToProps)(LandingPage);
